import HowItWorks from './HowItWorks';
export default HowItWorks;
